<template>
  <div>
    <component :is="videoComponent" ref="video" v-on="$listeners" noLayout :data="{url: videoUrl, poster: image ? `/media/${image.id}` : null}"/>
    <component :is="big ? 'h2': 'h3'" :class="{'big': big, 'small': !big}">{{title}}</component>
    <MarkdownBlock v-if="description" class="pt-2" :class="{'text-big': big, 'text-small': !big}" :text="description" />
  </div>
</template>

<script>
import { MarkdownBlock } from '@monogrid/vue-lib'
import ContentVideoYoutubePlayer from '@/atoms/ContentVideoYoutubePlayer'
import ContentVideoVimeoPlayer from '@/atoms/ContentVideoVimeoPlayer'

export default {
  name: 'MentoringResume',
  props: {
    title: { type: String },
    description: { type: String },
    videoUrl: { type: String },
    image: { type: Object },
    big: { type: Boolean }
  },
  components: { MarkdownBlock },
  computed: {
    videoComponent () {
      return this.videoUrl.indexOf('vimeo') === -1 ? ContentVideoYoutubePlayer : ContentVideoVimeoPlayer
    }
  },
  methods: {
    pause () {
      this.$refs.video.$refs.video.player.pause()
    }
  }
}
</script>

<style lang="scss" scoped>
.big {
  font-family: 'Brown', serif;
  font-size: 1.5rem;
  @include breakpoint('md-and-up') {
    font-size: 2rem;
  }
}

.small {
  font-family: 'Brown', serif;
  font-size: 1.5rem;
}

.text-small {
  @include breakpoint('md-and-up') {
    font-size: 0.9rem;
  }
}
</style>
